import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import SupplierLedgersTable from '../../views/economy-view/supplier-ledgers/supplier-ledgers-table';

export class InvoiceDetailsOutlays extends React.Component {

  static propTypes = {
    outlays: PropTypes.array,
    showDetailColumns: PropTypes.bool
  };

  renderOutlaysTable () {
    if (this.props.outlays.length) {
      return (<div className='invoice-details-expenses'>
        <SupplierLedgersTable
          supplierLedgers={this.props.outlays}
          showDetailColumns={this.props.showDetailColumns}
          hideOrderNumber
        />
      </div>);
    }

    return (<div className='invoice-details-border-container'>
      <Translate content='INVOICE_DETAILS_NO_DEDUCTIONS' />
    </div>);
  }

  render () {
    return (<div className='invoice-details-part-container'>
      <Translate className='invoice-details-title' content='INVOICE_DETAILS_DEDUCTION' />
      {this.renderOutlaysTable()}
    </div>);
  }
}

export default InvoiceDetailsOutlays;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/outlays.js
 **/